import React, { useContext } from 'react';

import ModalsContext from 'src/context/modals.jsx';
import SimpleModal from 'src/berry/ui-component/modals/SimpleModals.jsx';
import ItemDelete from 'src/modals/item_delete.jsx';

const big_modal = { width: 'auto', position: 'relative', top: 'unset', left: 'unset', transform: 'none', margin: '50px' };

const _modal2components = new Map([
	['file_delete', { content: <ItemDelete />, title: 'Delete file' }],
]);

const Modals = () => {
	const { modal, opened, hide } = useContext(ModalsContext);
	const component = _modal2components.get(modal);

	return <SimpleModal open={opened} on_close={hide} content={component?.content} title={component?.title} styles={component?.styles} />;
};

export default Modals;
